<template>
  <ui-button v-on:click.native="click" :backgroundColor="bgColor" color="#FFFFFF">
      <div slot="left"><spinner v-if="!active" color="#FFFFFF" :style='{fontSize:".9em"}'/></div>
      <div slot="title">{{ $t(title) }}</div>
      <div slot="right"></div>
  </ui-button>

</template>

<script>
import UiButton from '../UiButton.vue';
import Spinner from '../Spinner.vue';

export default {
  name: 'button-deactivate',
  props:{
    title:{default:"no title prop set."},
    active:{
      type:Boolean,
      default:true
    },
  },
  data:function(){
    return {
    }
  },
  methods:{
    click(event){
      if(!this.active){
        // prevent button events on further bubble
        event.stopImmediatePropagation();
      }
    }
  },
  computed:{
    bgColor:function(){
      if(this.active){
        return "#DD0000";
      }else{
        return "#707070";
      }
    }
  },
  mounted:function(){
    
  },
  components:{
    UiButton,
    Spinner,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  flex:1;
  text-align:right;
}
</style>
